import { OptionsObject, useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { Pie } from "react-chartjs-2";
import { getRelatedTopics } from "../../../api/statistics/keyword/KeywordStatisticsAPI";
import { AlertErrorProp } from "../../../components/SnackbarNoti";
import RandomColor from "../../../util/RandomColor";
import { Chart, registerables } from "chart.js";
import { useTranslation } from "react-i18next";
import { errorNoti } from "../../../util/SnackbarMessage";
Chart.register(...registerables);

type KeywordTimeProps = {
  keyword: string;
  time: number;
};

function RelatedTopicsChartWrapper(props: KeywordTimeProps) {
  const { t } = useTranslation(["common"]);
  const [topicData, setTopicData] = useState([]);
  const { enqueueSnackbar } = useSnackbar();

  const options = {
    plugins: {
      legend: { position: "bottom" as const, display: true },
      title: {
        display: true,
        text: "Chủ đề liên quan đến " + props.keyword,
      },
    },
    responsive: true,
  };

  useEffect(() => {
    getRelatedTopics(props.keyword, props.time)
      .then((res) => {
        setTopicData(res);
      })
      .catch((err) => {
        var noti = errorNoti(err);
        enqueueSnackbar(t("error:" + noti.message), noti.option);
      });
  }, [props.keyword, props.time]);

  const topicLabels = topicData.map((topic) => {
    return topic["topic"];
  });

  let colors = topicLabels.map((topic) => RandomColor({ name: topic }));

  const topicPoints = topicData.map((topic) => {
    return topic["points"];
  });

  const datasets = [
    {
      label: "topicLabels",
      data: topicPoints,
      backgroundColor: colors,
    },
  ];

  const data = {
    labels: topicLabels,
    datasets: datasets,
  };

  return (
    <div style={{ marginLeft: "auto", marginRight: "auto", width: "50%" }}>
      <Pie options={options} data={data}></Pie>
    </div>
  );
}

export default RelatedTopicsChartWrapper;
